import { useContext } from 'react';
import { PageMetadataContext } from '../context';

export const usePageMetadata = () => useContext(PageMetadataContext);
